/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Termsofuse2Inputs */

const he_footer_termsofuse2 = /** @type {(inputs: Footer_Termsofuse2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תנאי שימוש`)
};

const en_footer_termsofuse2 = /** @type {(inputs: Footer_Termsofuse2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Use`)
};

/**
* | output |
* | --- |
* | "Terms of Use" |
*
* @param {Footer_Termsofuse2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const footer_termsofuse2 = /** @type {((inputs?: Footer_Termsofuse2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Termsofuse2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_footer_termsofuse2(inputs)
	return en_footer_termsofuse2(inputs)
});
export { footer_termsofuse2 as "footer_termsOfUse" }